<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/solution3-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">制造</h2>
							<h4 class="text-left color-white">打通跨业务研制壁垒，激发智能制造创新</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">制造行业</h2>
				<div style="margin-top: 48px; font-size: 18px">
					数字技术加速和产业数字化转型升级，正带来制造业高质量发展的新机遇，催生未来新的产业链和商业模式。我们将创新智算基础设施、研制一体化工业互联网平台、物联网、产线打印解决方案等产品与服务注入制造业，促进产业互联，提供增长新动能。
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解决方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s3-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">研发一体化工业互联网平台</div>
						<div class="t2">通过 "一个生产模型，一套数据平台、一套流程机制 "，帮助大型制造企业将研发生产单元无缝整合至云端，实现跨地域的高效协同。</div>
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">产线智能巡检算力应用方案</div>
						<div class="t2">研发具有超强算力、全场景Al和开放生态等特点，为图像识别、视频处理、推理计算及机器学习等场景提供优质算力应用方案。</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/s3-2.png" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s3-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">智能制造线边搬运解决方案</div>
						<div class="t2">聚焦生产线边物料搬运，借助AMR、AGV、输送线等自动化设备，实现智能叫料、物料智能配送、智能搬运。</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		margin: 40px 36px;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}

}
</style>
